import axios from 'axios'

import { getToken } from '../services/auth'

const config = require('../configuracoes.json')

//TODO: Remover quando for arrumado a url: 'sveye-dev-frontend'
const LOCATIONS_HOST = ['localhost', '127.0.0.1', 'integra']

const isAmbienteProd = !LOCATIONS_HOST.some((host) =>
  window.location.host.includes(host)
)

const { host, port, protocol = 'http://' } = config.apiGateway
const api_gateway = axios.create({
  baseURL: isAmbienteProd
    ? `https://${host}`
    : `${protocol}${host}${port ? `:${port}` : ''}`
})

api_gateway.interceptors.request.use(async (config) => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`

  return config
})

const { baseURL, token } = config.apiOpenCellId
const api_opencellid = axios.create({ baseURL })

api_opencellid.interceptors.request.use(async (config) => {
  config.data.token = token
  return config
})

export { api_gateway, api_opencellid }

